import { BaseFolderSchema } from "@redotech/redo-model/views/folders";
import { viewWithIdSchemas } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

// Both purchase-orders and shipments use the same BaseViewWithId schema
const InventoryViewSchema = viewWithIdSchemas["purchase-orders"];

const ViewsAndFoldersSchema_ = z.object({
  folders: z.array(BaseFolderSchema),
  views: z.array(InventoryViewSchema),
});
export interface ViewsAndFoldersSchema
  extends z.infer<typeof ViewsAndFoldersSchema_> {}
export const ViewsAndFoldersSchema: z.ZodType<ViewsAndFoldersSchema> =
  ViewsAndFoldersSchema_;

export const getInventoryViewsAndFolders = {
  name: "getInventoryViewsAndFolders" as const,
  input: z.object({}),
  output: z.object({
    "purchase-orders": ViewsAndFoldersSchema,
    shipments: ViewsAndFoldersSchema,
    transfers: ViewsAndFoldersSchema,
    "inventory-levels": ViewsAndFoldersSchema,
    "catalog-products": ViewsAndFoldersSchema,
  }),
};
